import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '@ppl/ui';
import { LookupService } from '../../shared/services/lookup.service';
import { STATIC_DATA } from '../../shared/constants/static-data.constants';
import { ReferralLogicComponent } from "../leads/referral-logic/referral-logic.component";
import { ReferralDataService } from '../../services/referral-data.service';
import { SectionsService } from '../../services/sections.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ppl-dashboard',
  standalone: true,
  imports: [CommonModule, ReferralLogicComponent],
  templateUrl: './personal-assistant-registration.component.html',
  styleUrl: './personal-assistant-registration.component.css'
})
export class PersonalAssistantRegistration implements OnInit {
  savedData: any;
  state: any;

  constructor(
    private route: ActivatedRoute,
    private lookupService: LookupService,
    protected sectionService: SectionsService,
    protected referralDataService: ReferralDataService,
  ) {
  }

  ngOnInit(): void {
    this.state = this.route.snapshot.paramMap.get('state')!;
    this.sectionService.setState(this.state);
    this.referralDataService.setReferralFormData('state', this.state);

    localStorage.setItem("selected_program", '{"program_code":"Pre_Ref","program_name":"Leads Program","referenceId":0,"roles":[{"role_name":"PPL Admin","role_sid":1,"roleHierarchy":4}]}');
    this.sectionService.setFlow('providers');
    this.referralDataService.clearReferrralData();
    this.getLookupValues();
  }

  getLookupValues() {
    this.lookupService.fetchLookupValues().subscribe((lookupData) => {
      localStorage.setItem("lookup_values", JSON.stringify(lookupData));
      localStorage.setItem(STATIC_DATA.URL_FIRST_SEGMENT, 'providersEnrollmentList');
    })
  }
}
